export default __webpack_public_path__ + "static/media/Hair_19_F_C5.42e09b1c.svg";